import { Tooltip } from 'antd'
import iconChecked from 'assets/icons/check-preenchido.svg'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { getOverlayCustomTooltip } from 'utils/utils'
import './styles.scss'

interface CardRecommendationProps {
  question: string
  answer?: string | number | boolean
  isAlert?: boolean
  inconsistent?: boolean
  animated?: boolean
  url?: string
}

function CardFamilyAnswer({
  question,
  answer,
  inconsistent = false,
  isAlert = false,
  animated = true,
  url = '#',
}: CardRecommendationProps) {
  const { contrastIsSelected } = useAccessibility()

  const cardColor = useMemo(() => {
    if (inconsistent) return 'var(--yellow-secondary)'
    else if (!isAlert) return 'var(--green-700)'
    return 'var(--red-primary)'
  }, [inconsistent, isAlert])

  const cardIcon = useMemo(() => {
    if (inconsistent)
      return <span className="cardFamilyAnswer-inconsistentIcon">?</span>
    else if (!isAlert)
      return (
        <img
          src={iconChecked}
          alt="ok"
          height="30px"
          style={{ marginLeft: 'auto', marginRight: '2.3rem' }}
        />
      )
    return <span className="cardFamilyAnswer-alertIcon">!</span>
  }, [inconsistent, isAlert])

  const renderCard = useMemo(() => {
    return (
      <>
        <div className="cardFamilyAnswer-content">
          <h2>{question}</h2>
          <p>{answer ?? 'Não tem informação'}</p>
        </div>
        {cardIcon}
      </>
    )
  }, [question, answer, cardColor])

  if (inconsistent) {
    return (
      <Tooltip
        overlayClassName={'tooltip-cardFamilyAnswer'}
        placement="top"
        title={
          'Não é possível fazer recomendações para informações inconsistentes entre as bases.'
        }
        overlayStyle={getOverlayCustomTooltip(contrastIsSelected)}
        // overlayInnerStyle={getOverlayInnerCustomTooltipCardsInconsistency()}
        color={contrastIsSelected ? 'var(--contrast-background-color)' : ''}
      >
        <div
          className={
            'container-cardFamilyAnswer ' +
            (isAlert ? 'alert' : 'ok') +
            (inconsistent ? ' inconsistent' : '') +
            (animated ? ' cardAnimated' : '')
          }
          style={{ border: `1px solid ${cardColor}`, borderLeftWidth: '15px' }}
        >
          {renderCard}
        </div>{' '}
      </Tooltip>
    )
  }
  return (
    <Link
      className={
        'container-cardFamilyAnswer ' +
        (isAlert ? 'alert' : 'ok') +
        (inconsistent ? ' inconsistent' : '') +
        (animated ? ' cardAnimated' : '')
      }
      style={{ border: `1px solid ${cardColor}`, borderLeftWidth: '15px' }}
      to={inconsistent ? window.location.href : url}
    >
      {renderCard}
    </Link>
  )
}

export default CardFamilyAnswer
